import { t } from "i18next";

import { JSX, useState } from "react";

import BugReportIcon from "@mui/icons-material/BugReport";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import {
  DebugOptionsSelector,
  DebugSpeedDial,
  DebugSpeedDialAction,
} from "@plansoft-configuration-renderer/components";

const isDevEnvironment =
  window.location.href.includes("stag") ||
  window.location.href.includes("dev") ||
  window.location.href.includes("localhost");

export function CustomDebugSpeedDial(): JSX.Element {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      {isDevEnvironment && (
        <Box position="fixed" right="20px" bottom="20px" zIndex={99999}>
          <DebugSpeedDial
            icon={<BugReportIcon />}
            defaultIsOpen={false}
            FabProps={{
              sx: {
                backgroundColor: "warning.main",
              },
            }}
          >
            <DebugSpeedDialAction
              icon={<BugReportIcon />}
              tooltipTitle={t("showDebugDrawer")}
              onClick={() => setIsDrawerOpen(!isDrawerOpen)}
            />
          </DebugSpeedDial>
          <Drawer
            variant="temporary"
            anchor="right"
            open={isDrawerOpen}
            onClose={() => setIsDrawerOpen(false)}
          >
            <DebugOptionsSelector />
          </Drawer>
        </Box>
      )}
    </>
  );
}
